export default "__VITE_ASSET__320b36f6__"